import { render, staticRenderFns } from "./targetGroupContent.vue?vue&type=template&id=12220920&"
import script from "./targetGroupContent.vue?vue&type=script&lang=js&"
export * from "./targetGroupContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports